import React from "react"
import PropTypes from "prop-types"
import classnames from "classnames"
import {
  FacebookShareButton,
  LinkedinShareButton,
  WhatsappShareButton,
} from "react-share"
import copy from "copy-to-clipboard"

import styles from "./index.module.scss"
import { ReactComponent as ShareIcon } from "../../images/icons/shareIcon.svg"
import { ReactComponent as LinkIcon } from "../../images/icons/link.svg"
import { ReactComponent as XIcon } from "../../images/icons/xMark.svg"
import { ReactComponent as FacebookIcon } from "../../images/icons/facebook.svg"
import { ReactComponent as LinkedinIcon } from "../../images/icons/linkedin.svg"
import { ReactComponent as WhatsappIcon } from "../../images/icons/whatsapp.svg"
import useOutsideClicker from "../../hooks/useOutsideClicker"

const openXShare = (shareUrl, title) => {
  const params = new URLSearchParams({
    url: shareUrl,
    text: title || "",
    hashtags: "Bridge2Technologies",
  })
  window.open(
    `https://x.com/intent/tweet?${params.toString()}`,
    "_blank",
    "noopener,noreferrer",
  )
}

const Share = ({ title, description, url, children, type }) => {
  const [menuVisibility, setMenuVisibility] = React.useState(false)
  const [copyMsgVisibility, setCopyMsgVisibility] = React.useState(false)

  const menuRef = React.useRef(null)
  useOutsideClicker(menuRef, () => {
    setMenuVisibility(false)
  })

  const copLink = () => {
    copy(url)
    setCopyMsgVisibility(true)

    setTimeout(() => {
      setCopyMsgVisibility(false)
    }, 2500)
  }

  const isTray = type !== "outlined"
  const isOutlined = type === "outlined"

  const itemClassName = (network) =>
    classnames(
      styles.shareMenuItem,
      isTray && styles.shareMenuItemTray,
      isOutlined && styles.shareMenuItemOutlined,
      network && styles[`shareMenuItem_${network}`],
    )

  return (
    <div ref={menuRef} className={styles.shareMenu}>
      <div
        className={classnames(
          styles.shareMenuButton,
          isOutlined && styles.shareMenuButtonHidden,
        )}
        onClick={() => setMenuVisibility(!menuVisibility)}
      >
        {children || (
          <React.Fragment>
            <div className={styles.shareMenuButtonIcon}>
              <ShareIcon />
            </div>

            <span className={styles.shareMenuButtonText}>Share</span>
          </React.Fragment>
        )}
      </div>

      <div
        className={classnames(
          styles.shareMenuList,
          isTray && styles.shareMenuListTray,
          type === "horizontal" && styles.shareMenuListHorizontal,
          isOutlined && styles.shareMenuListStatic,
          menuVisibility && styles.shareMenuListVisible,
        )}
      >
        <div className={styles.shareMenuListContent}>
          <div className={itemClassName("copy")} onClick={copLink}>
            <div className={styles.shareMenuItemIcon}>
              <LinkIcon />
            </div>

            <div className={styles.shareMenuItemText}>Copy Link</div>

            <div
              className={classnames(
                styles.shareMenuItemCopyPopup,
                copyMsgVisibility && styles.shareMenuItemCopyPopupVisible,
              )}
            >
              Copied
            </div>
          </div>

          <button
            type="button"
            className={itemClassName("x")}
            onClick={() => openXShare(url, title)}
          >
            <div className={styles.shareMenuItemIcon}>
              <XIcon />
            </div>
            <div className={styles.shareMenuItemText}>X</div>
          </button>

          <FacebookShareButton
            url={url}
            quote={title}
            hashtag="Bridge2Technologies"
            className={itemClassName("facebook")}
          >
            <div className={styles.shareMenuItemIcon}>
              <FacebookIcon />
            </div>
            <div className={styles.shareMenuItemText}>Facebook</div>
          </FacebookShareButton>

          <WhatsappShareButton
            url={url}
            title={title}
            className={itemClassName("whatsapp")}
          >
            <div className={styles.shareMenuItemIcon}>
              <WhatsappIcon />
            </div>
            <div className={styles.shareMenuItemText}>WhatsApp</div>
          </WhatsappShareButton>

          <LinkedinShareButton
            url={url}
            title={title}
            summary={description || "https://private.theb2t.com/"}
            source="Bridge2Technologies"
            className={itemClassName("linkedin")}
          >
            <div className={styles.shareMenuItemIcon}>
              <LinkedinIcon />
            </div>
            <div className={styles.shareMenuItemText}>LinkedIn</div>
          </LinkedinShareButton>
        </div>
      </div>
    </div>
  )
}

Share.defaultProps = {
  description: null,
  type: null,
}

Share.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string,
  url: PropTypes.string.isRequired,
  type: PropTypes.oneOf(["horizontal", "outlined", null]),
}

export default Share
